import React, { forwardRef } from 'react';
import {
  Modal as FlowbiteModal,
  ModalBody as FlowbiteModalBody,
  ModalFooter as FlowbiteModalFooter,
  ModalHeader as FlowbiteModalHeader,
} from 'flowbite-react';
import { normalizeModalActions } from './actions';

export const Modal = forwardRef(function Modal({ className = '', theme, ...props }, ref) {
  return (
    <FlowbiteModal
      {...props}
      ref={ref}
      className={`app-modal ${className}`}
      theme={{
        ...theme,
        content: {
          ...theme?.content,
          inner:
            'app-modal-content relative flex max-h-[90dvh] flex-col rounded-2xl bg-white shadow-xl',
        },
      }}
    />
  );
});

export const ModalHeader = forwardRef(function ModalHeader({ className = '', ...props }, ref) {
  return <FlowbiteModalHeader {...props} ref={ref} className={`app-modal-header ${className}`} />;
});

export const ModalBody = forwardRef(function ModalBody({ className = '', ...props }, ref) {
  return <FlowbiteModalBody {...props} ref={ref} className={`app-modal-body ${className}`} />;
});

export const ModalFooter = forwardRef(function ModalFooter(
  { children, className = '', ...props },
  ref
) {
  return (
    <FlowbiteModalFooter {...props} ref={ref} className={`app-modal-footer ${className}`}>
      {normalizeModalActions(children)}
    </FlowbiteModalFooter>
  );
});
